import ContainerWithSteps from 'components/UI/Container/ContainerWithSteps'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useAppSelector } from 'hooks'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import { getUserRecord } from 'redux/store/slices/userSlice'
import { FLOW_STEPS } from 'share/types'
import tw from 'twin.macro'
import { getDearUserText, removeExtraWhitespace } from 'utils'

import NotarySelection from './NotarySelection'
import NotaryStatus from './NotaryStatus'

const NotaryPage = () => {
  // Tools
  const { t } = useTranslation()

  const { current_step, next_step } = useAppSelector(getStatusSelector)
  const { first_name, middle_name, gender } = useAppSelector(getUserRecord)

  const userName = getDearUserText({ gender, first_name, middle_name })

  const getView = useMemo(() => {
    if (current_step?.step === FLOW_STEPS.CHOOSING_NOTARY || next_step === FLOW_STEPS.CHOOSING_NOTARY) {
      return <NotarySelection />
    } else if (current_step?.step === FLOW_STEPS.DECISION_NOTARY || next_step === FLOW_STEPS.DECISION_NOTARY) {
      return <NotaryStatus />
    }
  }, [current_step?.step, next_step])

  if (current_step && !current_step.step) return null

  return (
    <ContainerWithSteps>
      <div>
        <div tw='px-4 md:px-0'>
          <Heading variant='title2'>{removeExtraWhitespace(userName)}</Heading>
          <Typography variant='subbody' twStyle={tw`text-grey-dark mt-2`}>
            {t('flow-inform-notary')}
          </Typography>
        </div>
        {getView}
      </div>
    </ContainerWithSteps>
  )
}

export default NotaryPage
